import { initialState } from "./initialState"
import { setBackupProductCode } from "./backupAgent"
import {
  onChangeBackupMode,
  onSaveBackupConsolePassword,
  onSelectBackupNode,
  onSaveBackupBandwidthThrottleKb,
  onSaveBackupBandwidthThrottle,
  onSaveBackupNetworkLocation,
} from "./backupSettings"

export default function backups(state = initialState(), action) {
  switch (action.type) {
    case "CUSTOMER_EDITOR_SET_BACKUP_PRODUCT_CODE":
      return setBackupProductCode(state, action)
    case "CUSTOMER_EDITOR_CHANGE_BACKUP_MODE":
      return onChangeBackupMode(state, action)
    case "CUSTOMER_EDITOR_SAVE_BACKUP_CONSOLE_PASSWORD":
      return onSaveBackupConsolePassword(state, action)
    case "CUSTOMER_EDITOR_SELECT_BACKUP_NODE":
      return onSelectBackupNode(state, action)
    case "CUSTOMER_EDITOR_SAVE_BACKUP_BANDWIDTH_THROTTLE":
      return onSaveBackupBandwidthThrottle(state, action)
    case "CUSTOMER_EDITOR_SAVE_BACKUP_BANDWIDTH_THROTTLE_KB":
      return onSaveBackupBandwidthThrottleKb(state, action)
    case "CUSTOMER_EDITOR_SAVE_BACKUP_NETWORK_LOCATION":
      return onSaveBackupNetworkLocation(state, action)
    case "CUSTOMER_EDITOR_INITIALIZE_BACKUPS":
      return initialState(action.backups)
    default:
      return state
  }
}
